import { useEffect, useRef } from "react"
import {
    dismissProcessingSnackbar,
    showProcessingSnackbar,
} from "routes/asset-register/plugins/asset-mapping/plugins/progress-card/progress-card-state"

export function useProcessingSnackbar(registerId, { busy, registerName }) {
    const snackbarDataRef = useRef({
        busy: false,
        registerName,
    })

    snackbarDataRef.current.busy = busy
    snackbarDataRef.current.registerName = registerName

    useEffect(handleProcessingSnackbar, [registerId])

    function handleProcessingSnackbar() {
        if (!registerId) return undefined

        dismissProcessingSnackbar(registerId)

        return function showSnackbarOnUnmount() {
            showSnackbarOnUnmountUsingLatestData(registerId)
        }
    }

    function showSnackbarOnUnmountUsingLatestData(registerId) {
        const { busy, registerName } = snackbarDataRef.current
        if (busy) {
            showProcessingSnackbar(registerId, { registerName })
        }
    }
}
